import { $axios } from "lib/axios";
import { TMember } from "types/auth/authTypes";

export const putResetPassword = async (params: {
  type: TMember;
  resetType?: "PHONE_NUMBER" | "EMAIL";
  password: string;
  authInfo?: string;
  verifiedTokenId: string;
}) => {
  const { type, resetType, verifiedTokenId, ...rest } = params;
  const res = await $axios.put(
    `/member/${type}/password${type === "corporation" ? `/${resetType}` : "/PHONE_NUMBER"}`,
    {
      verifiedTokenId,
      ...rest,
    }
  );
  return res.data;
};

export const patchVerificationFromFindPassword = async ({
  memberType,
  type,
  code,
  verificationId,
}: {
  memberType: TMember;
  type: "sms" | "email";
  code: string;
  verificationId: string;
}) => {
  const res = await $axios.patch(`/verification/password/${type}/${memberType}`, {
    code,
    verificationId,
  });

  return res.data;
};

export const postFindPwdVerification = async ({
  memberType,
  type,
  phoneNumber,
  email,
}: {
  memberType: "normal" | "corporation";
  type: "phoneNumber" | "email";
  phoneNumber?: string;
  email?: string;
}) => {
  const res = await $axios.post(
    `/member/${memberType}/password/${type === "email" ? "email" : "phone-number"}`,
    {
      ...(type === "email" ? { email } : { phoneNumber }),
    }
  );

  return res.data;
};
